import React, { FunctionComponent } from "react";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import {
  Overlay,
  ModalWrapper,
  Title,
  TitleText,
  ModalBody,
  List,
  ListItems,
  ListItem,
  BodyText,
  CallInfo,
  CallLink,
} from "./styles/non-premium-modal-styles";

const NonPremiumModal: FunctionComponent<unknown> = () => (
  <Overlay>
    <ModalWrapper className="animated delay fadeInDown">
      <Title>
        <TitleText>Get Premium</TitleText>
      </Title>
      <ModalBody>
        <BodyText>
          If managing multiple recruitment agencies (and recruitment processes)
          is taking up too much of your time, upgrade to our Premium Account
          service and we&apos;ll lighten your load. Upgrade to get:
          <List>
            <ListItems>
              <ListItem>
                <FontAwesomeIcon icon={faCheck} />
                Support posting jobs and uploading candidates to your ATS
              </ListItem>
              <ListItem>
                <FontAwesomeIcon icon={faCheck} />
                Expert curation and management of recruitment agencies
              </ListItem>
              <ListItem>
                <FontAwesomeIcon icon={faCheck} />
                Help scheduling interviews and assessments
              </ListItem>
              <ListItem>
                <FontAwesomeIcon icon={faCheck} />
                Offer and contract negotiation
              </ListItem>
              <ListItem>
                <FontAwesomeIcon icon={faCheck} />
                Data and analytics dashboard for greater insights
              </ListItem>
            </ListItems>
          </List>
        </BodyText>
        <CallInfo>
          To upgrade your account to <strong>Premium</strong> and start using it
          today,{" "}
          <strong>
            call your account manager on{" "}
            <CallLink
              href="tel:01613007235"
              data-tip="Click to make a call from this device"
              data-for="premium-call-action"
            >
              0161 300 7235
            </CallLink>
            .
          </strong>
        </CallInfo>
        <ReactTooltip
          place="top"
          type="dark"
          effect="solid"
          aria-haspopup="true"
          id="premium-call-action"
        />
      </ModalBody>
    </ModalWrapper>
  </Overlay>
);

export default NonPremiumModal;
